package ru.villawonka.app.presentation.screens.searchFilter.viewmodel

import ru.villawonka.app.common.mvvm.SingleLiveEvent
import ru.villawonka.app.domain.model.SearchParamsDomain

sealed interface SearchFilterUIEvent : SingleLiveEvent {

    data class Close(
        val searchParamsDomain: SearchParamsDomain?
    ) : SearchFilterUIEvent
}